import { faker } from "@faker-js/faker";
import { isoDateFromDateTime } from "../lib/dateTime.js";
import {
  UserLanguage,
  UserRole,
  type User,
  type WorkTimeEditLock,
} from "./user.js";

export const createUserMocks = ({
  count = 1,
  workTimeEditLockDays = 0,
  boss,
  absenceManagersId,
  refDate,
}: {
  count?: number;
  workTimeEditLockDays?: WorkTimeEditLock;
  boss?: number;
  absenceManagersId?: Array<number>;
  refDate?: Date;
}): Array<User> =>
  Array.from({ length: count }, (_, index): User => {
    const userId = index;
    const isFutureCoworker = faker.number.int({ min: 1, max: 10 }) === 1;
    const startDate = isFutureCoworker
      ? isoDateFromDateTime(
          faker.date.soon({ days: 365, ...(refDate ? { refDate } : {}) }),
        )
      : isoDateFromDateTime(
          faker.date.past({ ...(refDate ? { refDate } : {}) }),
        );

    return {
      id: userId,
      name: faker.person.fullName(),
      number: faker.string.hexadecimal(),
      email: faker.internet.email(),
      role: [UserRole.Owner, UserRole.Manager, UserRole.Worker][index % 3]!,
      active: faker.number.int({ min: 0, max: 10 }) > 2,
      timeformat12h: faker.datatype.boolean(),
      weekstartMonday: faker.datatype.boolean(),
      weekendFriday: faker.datatype.boolean(),
      language: [UserLanguage.De, UserLanguage.En, UserLanguage.Fr][index % 3]!,
      timezone: faker.location.timeZone(),
      wageType: null,
      canGenerallySeeAbsences: faker.datatype.boolean(),
      canGenerallyManageAbsences: faker.datatype.boolean(),
      canAddCustomers: faker.datatype.boolean(),
      worktimeRegulationId: null,
      teamsId: null,
      editLock: "2018-12-31",
      editLockDyn: null,
      editLockSync: faker.datatype.boolean(),
      nonbusinessGroupsId: null,
      initials: faker.string.alpha({ length: 2 }).toUpperCase(),
      workTimeEditLockDays,
      boss: boss ?? null,
      absenceManagersId: absenceManagersId ?? null,
      defaultHolidaysCount: false,
      defaultTargetHours: false,
      startDate,
      futureCoworker: isFutureCoworker,
      defaultWorkTimeRegulation: faker.datatype.boolean(),
      workTimeRegulationsId: null,
      budgetNotifications: faker.datatype.boolean(),
      creator: null,
    };
  });
